export default (theme) => ({
  h4: {
    fontWeight: 700,
  },
});
